import { render, staticRenderFns } from "./vipAgreement.vue?vue&type=template&id=2db22004&scoped=true&"
import script from "./vipAgreement.vue?vue&type=script&lang=js&"
export * from "./vipAgreement.vue?vue&type=script&lang=js&"
import style0 from "./vipAgreement.vue?vue&type=style&index=0&id=2db22004&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db22004",
  null
  
)

export default component.exports